import { z } from "zod";

// Common validation patterns
const representativeNameValidation = z
	.string()
	.min(1, { message: "Họ tên không được để trống" })
	.max(100, { message: "Họ tên không được vượt quá 100 ký tự" });

const emailValidation = z
	.string()
	.min(1, { message: "Email không được để trống" })
	.email({ message: "Email sai định dạng" });

const phoneNumberValidation = z
	.string()
	.min(1, { message: "Số điện thoại không được để trống" })
	.regex(/^[0-9+\-\s\(\)]{10,15}$/, { message: "Số điện thoại không hợp lệ" });

// Mentor consultation validation schema
export const MentorConsultationSchema = z.object({
	representativeName: representativeNameValidation,
	email: emailValidation,
	phoneNumber: phoneNumberValidation,
	consultationContent: z
		.string()
		.min(1, { message: "Nội dung tư vấn không được để trống" })
		.max(1000, { message: "Nội dung tư vấn không được vượt quá 1000 ký tự" }),
});

// Inhouse training consultation validation schema
export const InhouseTrainingSchema = z.object({
	representativeName: representativeNameValidation,
	email: emailValidation,
	phoneNumber: phoneNumberValidation,
	trainingTopic: z
		.string()
		.min(1, { message: "Chủ đề đào tạo không được để trống" })
		.max(1000, { message: "Chủ đề đào tạo không được vượt quá 1000 ký tự" }),
});

// Program building consultation validation schema
export const ProgramBuildingSchema = z.object({
	representativeName: representativeNameValidation,
	email: emailValidation,
	phoneNumber: phoneNumberValidation,
	consultationTopic: z
		.string()
		.min(1, { message: "Chủ đề tư vấn không được để trống" })
		.max(1000, { message: "Chủ đề tư vấn không được vượt quá 1000 ký tự" }),
});

// Export types
export type MentorConsultationFormData = z.infer<
	typeof MentorConsultationSchema
>;
export type InhouseTrainingFormData = z.infer<typeof InhouseTrainingSchema>;
export type ProgramBuildingFormData = z.infer<typeof ProgramBuildingSchema>;
